const register = () => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered: ', registration);
        })
        .catch((error) => {
          console.log('Service Worker registration failed: ', error);
        });
    }
  };
  
  const unregister = () => {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister();
      });
    }
  };
  
  export { register, unregister };
  